import { BasicCommand } from "./BasicCommand";
/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 26.08.13, 10:48
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */


import { BasicController } from "../BasicController";
import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { BasicErrorConstants } from "./constants/BasicErrorConstants";
import { SocialDataEvent } from "../../event/SocialDataEvent";
import { BasicModel } from "../../model/BasicModel";
import { BasicSocialData } from "../../model/components/social/BasicSocialData";
import { CommandController } from './../../../commanding/CommandController';
import { GGSCountryController } from './../../../language/countryMapper/GGSCountryController';
import { fatal } from "../../abTesting/ABTestController";
import { info } from "../../../logging/info";

export class SPLCommand extends BasicCommand {
    // TODO: User core error constant
    private static LOGIN_KEYS_INVALID: number = 10014;

    protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_NEW_LOGIN_SOCIAL;
    }

    public /*final*/ executeCommand(error: number, params: any[]): boolean {
        info("error: " + error + ", params: " + params);

        // Login keys "sig" and "suk" are invalid. Refresh them.
        if (error == SPLCommand.LOGIN_KEYS_INVALID) {
            // TODO: Should the screen be locked or a error dialog be shown?

            info("Signature key (sig) is outdated, request a new one.");

            // Listen for when the login keys are refreshed
            BasicController.getInstance().addEventListener(SocialDataEvent.LOGIN_KEYS_REFRESHED, this.bindFunction(this.onLoginKeysRefreshed));

            // The user have to do another click.
            CommandController.instance.executeCommand(BasicController.REQUEST_SOCIAL_LOGIN_KEYS);
            return false;
        }

        if (error == BasicErrorConstants.ALL_OK) {
            // Send session parameters to Javascript
            // sending should be done after GBD call from server when we have all the data see BasicSocialData

            // Reset, this was a successful login
            BasicModel.sessionData.loggedIn = true;

            // Don't save country for support key sessions
            if (this.env.suk == "") {
                BasicModel.localData.saveCountryData(GGSCountryController.instance.currentCountry.ggsCountryCode);
            }
        }

        this.handleGameSpecificErrors(error, params);
        return false;
    }

    private onLoginKeysRefreshed(event: SocialDataEvent): void {
        BasicController.getInstance().removeEventListener(SocialDataEvent.LOGIN_KEYS_REFRESHED, this.bindFunction(this.onLoginKeysRefreshed));

        this.retrySocialLogin();
    }

    private retrySocialLogin(): void {
        if (BasicModel.socialData.socialLoginReloginCount < BasicSocialData.LOGIN_RELOGIN_COUNT_MAX_TRIES) {
            info("Retry " + BasicModel.socialData.socialLoginReloginCount + ", try to execute social login again.");
            CommandController.instance.executeCommand(BasicController.COMMAND_SOCIAL_LOGIN);
        }
        else {
            fatal("Can't execute social login after " + BasicSocialData.LOGIN_RELOGIN_COUNT_MAX_TRIES + " tries!");

            // Delegate error to game
            this.handleGameSpecificErrors(SPLCommand.LOGIN_KEYS_INVALID, []);
        }

        BasicModel.socialData.socialLoginReloginCount++;
    }

    protected handleGameSpecificErrors(error: number, params: any[]): void {
    }
}
